import { isConfirmObligationBatchResponse, } from '@urbanik/api-contracts';
export class ObligationBatchConfirmationApiError extends Error {
    kind;
    constructor(kind, message) {
        super(message);
        this.kind = kind;
        this.name = 'ObligationBatchConfirmationApiError';
    }
}
export async function confirmObligationBatch(base, input) {
    let response;
    try {
        response = await fetch(`${base.replace(/\/$/, '')}/identity/collections/obligation-batches`, {
            method: 'POST',
            credentials: 'include',
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify(input),
        });
    }
    catch {
        throw new ObligationBatchConfirmationApiError('unavailable', 'No pudimos conectar con el servidor.');
    }
    const body = await response.json().catch(() => null);
    if (!response.ok) {
        const message = typeof body === 'object' &&
            body !== null &&
            'message' in body &&
            typeof body.message === 'string'
            ? body.message
            : 'No pudimos confirmar el lote.';
        throw new ObligationBatchConfirmationApiError(response.status === 401
            ? 'unauthorized'
            : response.status === 403
                ? 'forbidden'
                : response.status === 400
                    ? 'invalid'
                    : 'unavailable', message);
    }
    if (!isConfirmObligationBatchResponse(body))
        throw new ObligationBatchConfirmationApiError('invalid', 'El resumen del lote no es válido.');
    return body;
}
